export function getSenderIdentity(message, myId) {
    if (message.isOutbox) {
        return myId;
    }
    if (message.partnerId != null) {
        return message.partnerId;
    }
    return null;
}
